module.exports = __webpack_public_path__ + "capital-one-logo.svg";